// extracted by mini-css-extract-plugin
export var calculatorImage = "FixedPrice-module--calculator-image--15453";